import React, {FC} from 'react'
import styled from 'styled-components'
import {TextareaAutosize} from '@mui/material'
import {useAppSelector} from '../../hooks/redux'
import Editor from '../CKEditor/editor'
import MyDropzoneOne from '../myDropzone/myDropzoneOne'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

// export default function MinHeightTextarea() {
//   const blue = {
//     100: '#DAECFF',
//     200: '#b6daff',
//     400: '#3399FF',
//     500: '#007FFF',
//     600: '#0072E5',
//     900: '#003A75',
//   }

//   const grey = {
//     50: '#f6f8fa',
//     100: '#eaeef2',
//     200: '#d0d7de',
//     300: '#afb8c1',
//     400: '#8c959f',
//     500: '#6e7781',
//     600: '#57606a',
//     700: '#424a53',
//     800: '#32383f',
//     900: '#24292f',
//   }

const Title = styled(TextareaAutosize)(
    () => `
  text-overflow: ellipsis;
  resize: none;
  overflow-y: hidden;

  /* Display/L Semibold */
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 52px; /* 130% */
  letter-spacing: 0.8px;

  width: 100%;
  max-width: 100%;
  border: none;
  outline: none;

  overflow-y: auto;
  word-wrap: break-word;

  color: var(--text-main, #1a1a1a);
  ::placeholder {
    color: var(--text-secondary, #808080);
  }
  `
)
const Description = styled(TextareaAutosize)(
    () => `
  color: var(--text-main, #1a1a1a);
  text-align: justify;

  /* Paragraph/M */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.28px;

  margin: 25px 0px;

  resize: none;
  overflow: hidden;

  width: 100%;
  border: none;
  outline: none;
  `
)
type TitleDescriptionT = { name?: string; description?: string, files?: any[] }

type TitleDescriptionProps = TitleDescriptionT & {
    namePlaceholder?: string
    descriptionPlaceholder?: string
    callback: ({name, description}: TitleDescriptionT) => void
    onStartEditing?: () => void
    hasDescription?: boolean
    delay?: number
    files?: any[]
    language?: string
    onLanguageChange?: (lang: string, field: string, value: string) => void
}
const TitleDescriptionInput: FC<TitleDescriptionProps> = ({
    name = '',
    description = '',
    callback,
    onStartEditing,
    namePlaceholder = '',
    descriptionPlaceholder = '',
    hasDescription = true,
    language = 'en',
    onLanguageChange,
    files = [],
}) => {
    const {currentItem} = useAppSelector((state) => state)
    let isSubject = currentItem.type === 'subject'
    
    const handleChangeTitle = (value: string) => {
        // Не вызываем callback если значение не изменилось
        if (value === name) {
            return;
        }
        
        // Не вызываем callback если новое значение пустое, а текущее тоже пустое
        if ((value === '' || value === null || value === undefined) && 
            (name === '' || name === null || name === undefined)) {
            return;
        }
        
        // Устанавливаем флаг редактирования
        onStartEditing?.();
        
        // Если есть функция для изменения языка, используем её
        if (onLanguageChange) {
            onLanguageChange(language, 'name', value);
        } else {
            callback({ name: value });
        }
    }
    const handleChangeDescription = (value: string) => {
        // Не вызываем callback если значение не изменилось
        if (value === description) {
            return;
        }
        
        // Не вызываем callback если новое значение пустое, а текущее тоже пустое
        if ((value === '' || value === null || value === undefined) && 
            (description === '' || description === null || description === undefined)) {
            return;
        }
        
        // Устанавливаем флаг редактирования
        onStartEditing?.();
        
        // Если есть функция для изменения языка, используем её
        if (onLanguageChange) {
            onLanguageChange(language, 'description', value);
        } else {
            callback({ description: value });
        }
    }
    let isEditor = (global as any)?.isEditor;

    return (
        <Container>
            {/* <CKEditor/> */}
            {/* <div style={{left: 0, padding: '40px', top: 0, zIndex: 10000, background: 'red', position: 'absolute', width: '100%', height: '100%'}}> */}
            {/* </div> */}

            <div style={{display: 'flex', width: '100%'}}>
                <div style={{width: isSubject ? `calc(100% - 163px)`: '100%'}}>
                    {true && <Title
                        disabled={false}
                        style={{paddingLeft: 0}}
                        aria-label='minimum height'
                        // autoFocus={!isSubject}
                        minRows={1}
                        value={name}
                        placeholder={namePlaceholder || `Enter name ...`}
                        onChange={e => handleChangeTitle(e.target.value)}
                    />}
                    {hasDescription && (
                        <Editor
                            value={description}
                            onChange={(value: any) => {
                                handleChangeDescription(value)
                            }}
                            placeholder={descriptionPlaceholder || 'Enter field description ...'}
                        ></Editor>
                        // <Description
                        //   aria-label='minimum height'
                        //   minRows={1}
                        //   onChange={({ target: { value } }) => handleChangeDescription(value)}
                        //   value={description}
                        //   placeholder={descriptionPlaceholder || 'Enter field description ...'}
                        // />
                    )}
                </div>
                {isSubject && <div style={{width: '163px', marginBottom: '24px'}}>
                    <MyDropzoneOne files={files || []} onChange={(files: any) => {
                        callback({files})
                    }}></MyDropzoneOne>
                </div>}
            </div>
        </Container>
    )
}

export default TitleDescriptionInput
